import { Box, Grid } from '@mui/material';
import './index.scss';
import { getIndexMapping } from './helper';
import { TIndex } from '../../../utils/types/common';
import { colorMapping } from '../map/tiff/helper';
import { MVPFiltersProps } from '../constants';
import React from 'react';

export const LegendScale: React.FC<MVPFiltersProps> = ({
  selectedIndex,
  showData,
}) => {
  if (!selectedIndex) return <></>;

  const { indexLimits, indexBreakPoints } = getIndexMapping(
    selectedIndex as TIndex
  );

  const extendedIndexBreakPoints = [
    {
      label: 'Cloud cover',
      lowerValue: '',
      upperValue: '',
      valueColor: 'black',
    },
    ...indexBreakPoints, // Move the rest of the break points after the cloud cover
  ];

  const gradientColors = indexBreakPoints.map(
    ({ valueColor, lowerValue, upperValue }) => {
      if (valueColor) return valueColor;
      const { R, G, B } = colorMapping(
        selectedIndex,
        (lowerValue + upperValue) / 2
      );
      return `rgb(${R},${G},${B})`;
    }
  );

  return (
    <Box className="main-Box">
      {showData && (
        <Box className="legend-text">Legend :</Box>
      )}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center', // Align elements in a row
          width: '100%',
          marginTop: showData ? 5 : 2,
        }}>
        <Box
          sx={{
            backgroundColor: 'black',
            width: '40px', // Adjust size for visibility
            height: showData ? '20px' : '10px',
            marginLeft: 2,
          }}
        />
        {showData && (
          <Box component={'span'} className="zero-index">
            {indexLimits.lower}
          </Box>
        )}

        <Box
          sx={{
            display: 'inline-block',
            width: 'calc(100% - 40px)', // Adjust width to fill remaining space after black box
            height: showData ? '20px' : '10px',
            background: `linear-gradient(to right, ${gradientColors.join(
              ', '
            )})`,
          }}
        />

        {showData && (
          <Box component={'span'} className="first-index">
            {indexLimits.upper}
          </Box>
        )}
      </Box>

      <Grid
        container
        columns={extendedIndexBreakPoints.length}
        spacing={2}
        className={showData ? 'grid-box' : ''}>
        {extendedIndexBreakPoints.map(
          ({
            label,
            lowerValue,
            upperValue,
            valueColor: constValueColor,
          }) => {
            let valueColor = constValueColor;

            if (
              !valueColor &&
              lowerValue !== '' &&
              upperValue !== ''
            ) {
              const lower =
                typeof lowerValue === 'number'
                  ? lowerValue
                  : parseFloat(lowerValue);
              const upper =
                typeof upperValue === 'number'
                  ? upperValue
                  : parseFloat(upperValue);

              if (!isNaN(lower) && !isNaN(upper)) {
                const { R, G, B } = colorMapping(
                  selectedIndex,
                  (lower + upper) / 2
                );
                valueColor = `rgb(${R},${G},${B})`;
              }
            }

            return (
              <Grid item xs={1} key={label + selectedIndex}>
                <Box>
                  <Box sx={{ color: valueColor }}>
                    {lowerValue} to {upperValue}
                  </Box>
                  {showData && <Box>{label}</Box>}
                </Box>
              </Grid>
            );
          }
        )}
      </Grid>
    </Box>
  );
};
